import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcPreview = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.556 18 30 19.468l-.367.366C25.465 23.93 20.91 26 16 26c-5.053 0-9.732-2.195-14-6.532L3.444 18l.356.355c3.8 3.729 7.856 5.569 12.2 5.569 4.48 0 8.652-1.957 12.556-5.924ZM16 11a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0-7c4.806 0 9.267 1.995 13.348 5.94l.36.353-1.415 1.414C24.47 9.886 20.386 8 16 8c-4.253 0-8.224 1.773-11.945 5.365l-.348.342-1.414-1.414C6.47 8.114 11.053 6 16 6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcPreview;
